import type { QueryClient } from "@tanstack/react-query";

export type InvalidatePatientsCacheInput = {
  ownerId?: string | null;
  petIds?: string[] | null;
};

/**
 * Invalidates all React Query caches related to owners/pets ("patients") and any
 * screens/searches that depend on them.
 *
 * Note: uses prefix matching (exact: false) to catch all parameterized variants.
 */
export function invalidatePatientsCache(
  queryClient: QueryClient,
  input?: InvalidatePatientsCacheInput,
): void {
  const prefixes: Array<readonly unknown[]> = [
    // Core
    ["owners"],
    ["owner"],
    ["pets"],
    ["pet"],
    ["pet-summary"],

    // Unified list + searches
    ["owners-with-pets"],
    ["owner-search"],
    ["global-search"],

    // Owner detail pets list (reported bug)
    ["owner-pets"],

    // Patient/owner history and upcoming care surfaces
    ["patient-history"],
    ["patient-history-feed"],
    ["appointments", "patient-history"],
    ["owner-history-timeline"],
    ["owner-history-feed"],
    ["future-rows-appointments"],
    ["application-follow-up-tracking"],
  ];

  for (const queryKey of prefixes) {
    queryClient.invalidateQueries({ queryKey, exact: false });
  }

  if (input?.ownerId) {
    queryClient.invalidateQueries({ queryKey: ["owner-pets", input.ownerId], exact: false });
  }
}
